import { render, staticRenderFns } from "./ProposalTag.vue?vue&type=template&id=29bc1213"
import script from "./ProposalTag.vue?vue&type=script&lang=js"
export * from "./ProposalTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports